import React from 'react';
import ReactSwitch from 'react-switch';

export interface WithToggleSwitchProps {
  isChecked: boolean;
  onChange: (
    checked: boolean,
    event: React.SyntheticEvent<MouseEvent | KeyboardEvent> | MouseEvent,
    id: string,
  ) => void;
}

export const WithToggleSwitch: React.FC<WithToggleSwitchProps> = ({ isChecked, onChange }) => {
  return (
    <div>
      <div className="flex-1 flex justify-end absolute top-0 right-0">
        <div className={'flex flex-row gap-2 mb-1'} data-testid="exclude-toggle-switch">
          <span className={'text-sm py-1 line-truncate'} title={'exclude'}>
            exclude
          </span>
          <span className={'py-1'}>
            <ReactSwitch
              checked={isChecked}
              onChange={onChange}
              onColor="#E55A00"
              height={23}
              width={48}
              title={'exclude'}
            />
          </span>
        </div>
      </div>
    </div>
  );
};
